import { ResizeObserverBoxOptions as z } from "./highrise1821.mjs";
import { ResizeObserverSize as X } from "./highrise1748.mjs";
import { DOMRectReadOnly as P } from "./highrise1822.mjs";
import { isHidden as A, isSVG as I } from "./highrise1745.mjs";
import { freeze as O } from "./highrise1747.mjs";
import { global as R } from "./highrise1823.mjs";
var l = /* @__PURE__ */ new WeakMap(), S = /auto|scroll/, G = /^tb|vertical/, N = /msie|trident/i.test(R.navigator && R.navigator.userAgent), i = function(e) {
  return parseFloat(e || "0");
}, a = function(e, t, r) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), r === void 0 && (r = !1), new X((r ? t : e) || 0, (r ? e : t) || 0);
}, w = O({
  devicePixelContentBoxSize: a(),
  borderBoxSize: a(),
  contentBoxSize: a(),
  contentRect: new P(0, 0, 0, 0)
}), F = function(e, t) {
  if (t === void 0 && (t = !1), l.has(e) && !t)
    return l.get(e);
  if (A(e))
    return l.set(e, w), w;
  var r = getComputedStyle(e), o = I(e) && e.ownerSVGElement && e.getBBox(), d = !N && r.boxSizing === "border-box", n = G.test(r.writingMode || ""), s = !o && S.test(r.overflowY || ""), W = !o && S.test(r.overflowX || ""), B = o ? 0 : i(r.paddingTop), T = o ? 0 : i(r.paddingRight), C = o ? 0 : i(r.paddingBottom), f = o ? 0 : i(r.paddingLeft), E = o ? 0 : i(r.borderTopWidth), H = o ? 0 : i(r.borderRightWidth), L = o ? 0 : i(r.borderBottomWidth), M = o ? 0 : i(r.borderLeftWidth), p = f + T, g = B + C, h = M + H, x = E + L, b = W ? e.offsetHeight - x - e.clientHeight : 0, m = s ? e.offsetWidth - h - e.clientWidth : 0, _ = d ? p + h : 0, y = d ? g + x : 0, v = o ? o.width : i(r.width) - _ - m, c = o ? o.height : i(r.height) - y - b, D = v + p + m + h, V = c + g + b + x, u = O({
    devicePixelContentBoxSize: a(Math.round(v * devicePixelRatio), Math.round(c * devicePixelRatio), n),
    borderBoxSize: a(D, V, n),
    contentBoxSize: a(v, c, n),
    contentRect: new P(f, B, v, c)
  });
  return l.set(e, u), u;
}, Q = function(e, t, r) {
  var o = F(e, r), d = o.borderBoxSize, n = o.contentBoxSize, s = o.devicePixelContentBoxSize;
  switch (t) {
    case z.DEVICE_PIXEL_CONTENT_BOX:
      return s;
    case z.BORDER_BOX:
      return d;
    default:
      return n;
  }
};
export {
  Q as calculateBoxSize,
  F as calculateBoxSizes
};
